"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Flash_1 = require("../../components/Flash");
Flash_1.Flash.each('.menu-link[href="/mijn-bnr"]');
